module.exports = __webpack_public_path__ + "media/images/emblems/Boningen-blason-71a12b1010c0e4ca7fede1976d7c8c53.png";